import { Locale } from '@front/i18n';

import {
  COUNTRIES,
  CURRENCIES_BY_COUNTRY,
  CURRENCY_SYMBOLS,
  DEFAULT_COUNTRY,
  LOCALES_BY_COUNTRY,
  PRO_PERMISSIONS_BY_COUNTRY,
  ProCountryPermission,
  SORTED_PRO_UNIVERSES,
  TIMEZONES_BY_COUNTRY,
  WECASA_HOMEPAGE_LINK_BY_COUNTRY,
} from '../constants/country';
import { Country } from '../types/country';

import moment from './moment';

import 'moment-timezone';

let currentCountry: Country | undefined;

export const getCurrentCountry = () => currentCountry || DEFAULT_COUNTRY;

export const getCurrentCurrency = () => CURRENCIES_BY_COUNTRY[getCurrentCountry()];

export const getCurrentCurrencySymbol = () => CURRENCY_SYMBOLS[getCurrentCurrency()];

/**
 * The backend sets the timezone depending on the country, we do the same here.
 */
export const getCurrentTimezone = () => TIMEZONES_BY_COUNTRY[getCurrentCountry()];

export const setCurrentCountry = (country?: Country) => {
  currentCountry = country;
  moment.tz.setDefault(getCurrentTimezone());
};

export const setDefaultCountry = () => {
  setCurrentCountry(DEFAULT_COUNTRY);
};

export const hasCountryProPermission = (permission: ProCountryPermission, country?: Country) =>
  PRO_PERMISSIONS_BY_COUNTRY[country || getCurrentCountry()].includes(permission);

export const isCountryFR = () => getCurrentCountry() === COUNTRIES.FR;
export const isCountryGB = () => getCurrentCountry() === COUNTRIES.GB;
export const isCountryDE = () => getCurrentCountry() === COUNTRIES.DE;
export const isCountryCH = () => getCurrentCountry() === COUNTRIES.CH;
export const isCountryAT = () => getCurrentCountry() === COUNTRIES.AT;

export const isCountryMultiLocale = () => LOCALES_BY_COUNTRY[getCurrentCountry()].length > 1;

export const isCountrySingleUniverse = () => SORTED_PRO_UNIVERSES[getCurrentCountry()].length === 1;

export const getHomePageUrl = (locale: Locale) =>
  `${WECASA_HOMEPAGE_LINK_BY_COUNTRY[getCurrentCountry()]}${isCountryMultiLocale() ? `/${locale.toLowerCase()}` : ''}`;
